import React, {Component} from 'react';
import './App.css';
import YouTube from './media/youtube.svg';
import Email from './media/email.svg';
import {Button, FormControl, FormHelperText, Grid, Input, InputLabel, MuiThemeProvider, Tooltip} from "material-ui";
import {createMuiTheme} from 'material-ui/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#ffffff',
            main: '#455a64',
            dark: '#000000',
            contrastText: '#fff',
        }
    }
});

class App extends Component {
    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <div className="App">
                    <div id="logo">SAMANTHA HAYES</div>
                    <SocialIcons/>
                    <SubscribeForm/>
                </div>
            </MuiThemeProvider>
        );
    }
}

function SocialIcons() {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Grid container alignItems="center" id="social-wrapper" justify="flex-end">
                    <Tooltip id="tooltip-bottom" title="YouTube" placement="bottom">
                        <a href="https://www.youtube.com/channel/UCmbOegoEB10HZ-Nzwq3fBjw" rel="noopener noreferrer"
                           target="_blank">
                            <img alt="YouTube" className="SocialIcons" src={YouTube}/>
                        </a>
                    </Tooltip>
                    <Tooltip id="tooltip-bottom" title="Email Samantha" placement="bottom">
                        <a href="mailto:enquiries@samanthahayesmusic.com?Subject=Website%20Enquiry%20(Samantha%20Hayes%20Music)"
                           target="_top">
                            <img alt="Email" className="SocialIcons" src={Email}/>
                        </a>
                    </Tooltip>
                </Grid>
            </Grid>
        </Grid>
    );
}

class SubscribeForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            gotcha: '',
            open: false,
            FNAME: '',
            nameHelper: '',
            nameHelperState: false,
            EMAIL: '',
            emailHelperNoText: '',
            emailHelperState: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleInputState = this.handleInputState.bind(this);
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;
        this.setState({
            [name]: target.value
        });
        this.handleInputState(event);
    }

    handleInputState(event) {
        const target = event.target;
        const name = target.name;
        let helperName, helper, helperStateName, helperState;
        if (target.value != null) {
            if (target.value.length === 0) {
                if (name === 'FNAME') {
                    helperName = 'nameHelper';
                    helper = 'Please include your name';
                    helperStateName = 'nameHelperState';
                    helperState = true;
                } else if (name === 'EMAIL') {
                    helperName = 'emailHelperNoText';
                    helper = 'Please include your email';
                    helperStateName = 'emailHelperState';
                    helperState = true;
                }
            } else {
                if (name === 'FNAME') {
                    helperName = 'nameHelper';
                    helper = '';
                    helperStateName = 'nameHelperState';
                    helperState = false;
                } else if (name === 'EMAIL') {
                    helperName = 'emailHelperNoText';
                    helper = '';
                    helperStateName = 'emailHelperState';
                    helperState = false;
                }
            }
            this.setState({
                [helperName]: helper,
                [helperStateName]: helperState
            });
        }
    }

    render() {
        return (
            <div className="Form">
                <p style={{textAlign: 'center'}}>
                    Sign up to Samantha's newsletter to receive her latest news
                </p>
                <form
                    action="https://sammyhayes.us4.list-manage.com/subscribe/post?u=691cd5fa2f3030ee381a09b53&amp;id=9de41e204a"
                    method="post" name="mc-embedded-subscribe-form" target="_self" noValidate>
                    <Grid container alignItems="center" justify="center">
                        <Grid item>
                            <FormControl aria-describedby="name-error-text" error={this.state.nameHelperState}
                                         fullWidth required>
                                <InputLabel htmlFor="name-input">Name</InputLabel>
                                <Input id="name-input" name="FNAME" onChange={this.handleChange}
                                       onFocus={this.handleInputState} type="text"/>
                                <FormHelperText id="name-error-text"
                                                value={this.state.nameHelper}>{this.state.nameHelper}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl aria-describedby="email-error-text" error={this.state.emailHelperState}
                                         fullWidth required>
                                <InputLabel htmlFor="email-input">Email</InputLabel>
                                <Input id="email-input" name="EMAIL" onChange={this.handleChange}
                                       onFocus={this.handleInputState} type="email"/>
                                <FormHelperText id="email-error-text"
                                                value={this.state.emailHelperNoText}>{this.state.emailHelperNoText}</FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container alignItems="center" justify="center">
                        <input name="gotcha" onChange={this.handleChange} style={{display: 'none'}}
                               type="text" value={this.state.gotcha}/>
                        <Grid item>
                            <Button color="primary" type="submit" name="subscribe"
                                    disabled={this.state.FNAME.length === 0 || this.state.EMAIL.length === 0 || this.state.gotcha.length > 0}
                                    style={{}}
                                    variant="raised">
                                Subscribe
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </div>
        );
    }

}

export default App;


// WEBPACK FOOTER //
// ./src/App.js